import { Logger } from './Logger';

export interface ApiErrorInfo {
  status: number;
  statusText: string;
  endpoint: string;
  url: string;
  timestamp: string;
  message: string;
}

export class ApiErrorHandler {
  static async handleApiError(
    response: Response,
    endpoint: string,
    url: string
  ): Promise<never> {
    const errorText = await response.text();
    Logger.error(`❌ ${endpoint} Error:`, errorText);

    let errorData;
    try {
      const parsed = JSON.parse(errorText);
      // Handle envelope error format: { success: false, error: { code, message } }
      if (parsed.success === false && parsed.error) {
        errorData = {
          message: parsed.error.message || 'An error occurred',
          code: parsed.error.code,
          status: response.status
        };
      } else if (parsed.message) {
        // Handle flat format: { message: "..." }
        errorData = parsed;
      } else {
        errorData = { message: errorText, status: response.status };
      }
    } catch {
      errorData = { message: errorText, status: response.status };
    }

    const error = new Error(`${endpoint} failed: ${response.status} ${response.statusText}`);
    (error as any).apiResponse = {
      ...errorData,
      status: response.status,
      statusText: response.statusText,
      endpoint,
      url,
      timestamp: new Date().toISOString()
    } as ApiErrorInfo;
    (error as any).status = response.status;
    throw error;
  }
}